import { useSelector } from 'react-redux';
import { isCustomerSite } from '../utils/getsubDomain';

export default function useAccount() {
    const {userData: {user}} = useSelector(state => state.user);
    const {settings} = useSelector(state => state.settings);

    function getAccountPermissions() {
        const permissions = settings?.roles?.filter(role => user?.roles?.includes(role?._id))?.reduce((acc, role) => ({
            permissions: [...acc.permissions, ...((role?.permissions || [])?.filter(name => !acc.permissions?.includes(name)))],
        }),{permissions: []})

        return permissions || []
    }

    function checkPermission(permission) {
      if(isCustomerSite()) return true;
      if(user?.userType === 'Agent') return true;
      let permissions = permission;
      if(!Array.isArray(permission))
        permissions = [permission];

      const result = getAccountPermissions();
      const isAdmin = user?.userType === 'Admin'
      return isAdmin || result?.permissions?.find(permission => permissions?.includes(permission)) || false;
    }
    
  return {
    getAccountPermissions,
    checkPermission,
  }
}
